import type { SlateBlock, SlateLeaf } from '@atlas/renderer';
import { Editor } from 'slate';

export default function matchNode<Result extends SlateBlock | SlateLeaf>(
    editor: Editor,
    match: (node: SlateBlock | SlateLeaf) => boolean,
    mode: 'all' | 'highest' | 'lowest' = 'lowest',
): Result | undefined {
    const nodes = Editor.nodes(editor, {
        match: (node) => !Editor.isEditor(node) && match(node as SlateBlock | SlateLeaf),
        mode,
    });

    const [matched] = Array.from(nodes);

    if (!matched) return;
    return matched[0] as Result;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('matchNode', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
